/**
 * Firefox prints a blank page when react-to-print's iframe is parked outside
 * the viewport and removed as soon as `print()` returns. `print()` does not
 * block in Firefox, so the preview snapshots an empty frame.
 */
export const printIframeDocument = (printIframe: HTMLIFrameElement, documentTitle?: string): Promise<void> =>
    new Promise((resolve, reject) => {
        const printWindow = printIframe.contentWindow
        if (!printWindow) {
            resolve()
            return
        }

        printIframe.style.position = "fixed"
        printIframe.style.top = "0"
        printIframe.style.left = "0"
        printIframe.style.width = "100%"
        printIframe.style.height = "100%"
        printIframe.style.border = "0"
        printIframe.style.opacity = "0"
        printIframe.style.pointerEvents = "none"

        const ownerDocument = printIframe.ownerDocument
        const previousTitle = ownerDocument.title
        if (documentTitle) {
            ownerDocument.title = documentTitle
            if (printIframe.contentDocument) {
                printIframe.contentDocument.title = documentTitle
            }
        }

        let settled = false
        const finish = () => {
            if (settled) return
            settled = true
            printWindow.removeEventListener("afterprint", finish)
            if (documentTitle) {
                ownerDocument.title = previousTitle
            }
            resolve()
        }

        printWindow.addEventListener("afterprint", finish)
        try {
            printWindow.focus()
            printWindow.print()
        } catch (error) {
            printWindow.removeEventListener("afterprint", finish)
            if (documentTitle) {
                ownerDocument.title = previousTitle
            }
            reject(error)
        }
    })
